/** Email from IAM `/user/api/account` — used as `uploadedBy` for greeting file download. */
export function resolveGreetingUploadedBy(session) {
    const email = session?.account?.email?.trim();
    if (email) {
        return email;
    }
    return session?.username?.trim() ?? '';
}
